import { render, staticRenderFns } from "./testresults.vue?vue&type=template&id=08c1951a&scoped=true&"
import script from "./testresults.vue?vue&type=script&lang=js&"
export * from "./testresults.vue?vue&type=script&lang=js&"
import style0 from "./testresults.vue?vue&type=style&index=0&id=08c1951a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c1951a",
  null
  
)

export default component.exports